import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="font-display bg-background-light dark:bg-background-dark min-h-screen">
      <div className="px-4 sm:px-10 md:px-20 lg:px-40">
        <Header />
        
        <div className="py-12 max-w-4xl mx-auto">
          <h1 className="text-4xl font-black text-gray-900 dark:text-white mb-8">
            Política de Privacidad
          </h1>
          
          <div className="prose dark:prose-invert max-w-none">
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              Última actualización: 7 de diciembre de 2025
            </p>
            
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">1. Información que Recopilamos</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Recopilamos las siguientes categorías de información:
              </p>
              
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 mt-4">1.1. Información de Cuenta</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Nombre</li>
                <li>Correo electrónico</li>
                <li>Contraseña (almacenada mediante encriptación avanzada)</li>
              </ul>

              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 mt-4">1.2. Información de Uso</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Prompts ingresados</li>
                <li>Registros de actividad</li>
                <li>Historial de chats y generaciones</li>
                <li>Interacciones con módulos de la plataforma</li>
              </ul>

              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 mt-4">1.3. Información de Pago</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Procesada exclusivamente por proveedores externos (Stripe, PayPal).</li>
                <li>GPT-JDP no almacena datos de tarjetas.</li>
              </ul>

              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 mt-4">1.4. Información Técnica</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Dirección IP</li>
                <li>Tipo de navegador</li>
                <li>Sistema operativo</li>
                <li>Identificadores únicos de dispositivo</li>
                <li>Datos de rendimiento y telemetría</li>
              </ul>

              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 mt-4">1.5. Cookies y Tecnologías Similares</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Utilizadas para sesión, rendimiento y analítica.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">2. Finalidades del Tratamiento de Datos</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Utilizamos su información para:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Proveer, operar y mejorar la plataforma</li>
                <li>Gestionar suscripciones y pagos</li>
                <li>Proveer soporte técnico</li>
                <li>Personalizar la experiencia del usuario</li>
                <li>Mantener integridad y seguridad del servicio</li>
                <li>Analizar tendencias y uso general</li>
                <li>Cumplimiento de normativas legales</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">3. Bases Legales para el Tratamiento (GDPR & Normativas Internacionales)</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                El tratamiento de datos se basa en:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Ejecución de un contrato (uso del servicio)</li>
                <li>Consentimiento explícito (cookies, newsletters)</li>
                <li>Interés legítimo (seguridad, prevención de fraude)</li>
                <li>Cumplimiento de obligaciones legales</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">4. Compartición de Información</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                No vendemos su información personal.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Podemos compartir información únicamente con:
              </p>

              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 mt-4">4.1. Proveedores de Servicios</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Procesadores de IA</li>
                <li>Servicios de infraestructura</li>
                <li>Sistemas de almacenamiento y bases de datos</li>
              </ul>

              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 mt-4">4.2. Procesadores de Pago</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Stripe</li>
                <li>PayPal</li>
              </ul>

              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 mt-4">4.3. Cumplimiento Legal</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Cuando sea requerido por ley, tribunales o autoridades reguladoras.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">5. Seguridad de los Datos</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                GPT-JDP implementa medidas de seguridad avanzadas de nivel empresarial, incluyendo:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Encriptación de datos en tránsito (HTTPS/TLS 1.3)</li>
                <li>Encriptación de contraseñas con bcrypt y sal aleatoria</li>
                <li>Autenticación segura mediante tokens JWT</li>
                <li>Segmentación de bases de datos y acceso mínimo necesario</li>
                <li>Monitoreo constante de integridad del sistema</li>
                <li>Copias de seguridad automatizadas</li>
                <li>Auditorías internas de seguridad</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Además, la plataforma opera bajo un marco de seguridad certificado que cumple estándares superiores de resguardo y control, garantizando protección reforzada contra accesos no autorizados y ataques avanzados.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">6. Sus Derechos</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Según la legislación aplicable, usted tiene derecho a:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Acceder a sus datos</li>
                <li>Rectificar información incorrecta</li>
                <li>Solicitar eliminación de datos</li>
                <li>Solicitar portabilidad</li>
                <li>Oponerse a ciertos tratamientos</li>
                <li>Solicitar restricción en el procesamiento</li>
                <li>Retirar su consentimiento</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Solicitudes: ceo@gpt-jdp.com
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">7. Retención de Datos</h2>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Datos de usuario: eliminados dentro de 30 días tras cierre de cuenta</li>
                <li>Contenido generado: eliminado dentro de 30 días</li>
                <li>Registros financieros y transacciones: conservados por 7 años (obligación legal)</li>
                <li>Registros técnicos: según necesidades operativas, no más de 12 meses</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">8. Cookies y Tecnologías Similares</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Usamos cookies para:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li><strong>Esenciales:</strong> autenticación y sesión</li>
                <li><strong>Preferencias:</strong> idioma, configuraciones</li>
                <li><strong>Analíticas:</strong> métricas de uso</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Puede desactivarlas desde su navegador, aunque esto puede limitar funciones.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">9. Transferencias Internacionales</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Sus datos pueden ser procesados en servidores ubicados fuera de Chile.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Garantizamos protección mediante:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Acuerdos de procesamiento de datos</li>
                <li>Cláusulas Contractuales Estándar (SCC)</li>
                <li>Estándares equivalentes al GDPR</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">10. Privacidad de Menores</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                El servicio no está dirigido a menores de 18 años.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Si detectamos datos de un menor, serán eliminados inmediatamente.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">11. Cambios a esta Política</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Podemos actualizar esta política ocasionalmente.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Los cambios significativos serán notificados por correo electrónico o dentro de la plataforma.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">12. Contacto</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Para consultas sobre privacidad:
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-2">
                Email: ceo@gpt-jdp.com
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-2">
                Sitio web: www.gpt-jdp.com
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Dirección: Santiago, Chile
              </p>
            </section>
          </div>
        </div>
        
        <Footer />
      </div>
    </div>
  );
};

export default PrivacyPolicy;